//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "KarriereIndexPage",
  transition: "default",
  async asyncData({ $axios, params, error }) {
    try {
      const qs = require("qs");
      const query = qs.stringify(
        {
          // publicationState: "preview",
          filters: {
            slug: {
              $eq: "karriere",
            },
          },
        },
        {
          encodeValuesOnly: true,
        }
      );
      // console.log("KARRIERE QUERY: " + query);
      const karriereSeiteData = await $axios.$get(
        `${process.env.api_url}/api/pages?${query}&populate=deep&locale=all`
      );
      const breakBlockData = await $axios.$get(
        `${process.env.api_url}/api/boxes-break-blocks?populate=deep&locale=all`
      );
      // console.log("KARRIERE PARAMS: ", params);
      // console.log("KARRIERE DATA: ", data.data);
      return {
        data: {
          karriereSeiteData: karriereSeiteData.data[0],
          breakBlockData:
            breakBlockData.data.length && breakBlockData.data[0].attributes
        },
      };
    } catch (err) {
      error({
        statusCode: 404,
        message: "Page not found",
      });
    }
  },
  // head() removed - Page.vue component handles meta tags and canonical URL
};
